export const vahanDataList = [
    [
        "vehicleNumber",
        "vehicleManufacturerName",
        "model",
        "vehicleColour",
        "type",
        "bodyType",
        "regAuthority",
        "regDate",
        "rcExpiryDate",
        "vehicleSeatCapacity",
    ],
    [
        "class",
        "chassis",
        "engine",
        "status",
        "statusAsOn",
        "vehicleManufacturingMonthYear",
        "vehicleCubicCapacity",
        "vehicleCategory",
        "vehicleCylindersNo",
        "blacklistStatus",
    ],
    [
        "owner",
        "ownerFatherName",
        "ownerCount",
        "vehicleInsuranceCompanyName",
        "vehicleInsuranceUpto"
    ],
    [
        "isCommercial",
        "presentAddress",
        "presentPincode",
        "permanentAddress",
        "permanentPincode"
    ]
];

export const challanDataList = [
    "challanNumber",
    "challanDate",
    "state",
    "amount",
    "challanStatus",
    "offenseDetails",
    "accusedName"
];

export const panVerificationDataList = [
    [
        "name",
        "firstName",
        "middleName",
        "lastName",
        "title"
    ],
    [
        "typeOfHolder",
        "isIndividual",
        "isValid",
        "number"
    ],
    [
        "panStatus",
        "panStatusCode",
        "aadhaarSeedingStatus",
        "aadhaarSeedingStatusCode",
        "lastUpdatedOn"
    ]
];

export const dlVerificationDataList = [
    "message",
    "dateOfIssue",
    "expiryDate"
];

export const aadhaarDataList = [
    "verified",
    "ageBand",
    "mobileNumber",
    "state",
    "gender"
]